import React from 'react';

function Icon({ color = '#B7BDBC', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" fill="none" viewBox="0 0 14 8" {...props}>
            <path fill={color} d="M7 5.172l4.95-4.95 1.414 1.414L7 8 .636 1.636 2.05.222 7 5.172z"></path>
        </svg>
    );
}

export default Icon;
